export default __webpack_public_path__ + "static/media/10_citybank.6f11f3e1.png";